import {
  Box,
  Paper,
  Typography,
  ThemeProvider,
  createTheme,
} from '@mui/material';

const forceMdTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 0,
      md: 0, // everything is >= md
      lg: 99999,
      xl: 99999,
    },
  },
});

const PrintWrapper = ({ title, description, children, isPreview }) => (
  <Box sx={isPreview && { '.non-printable': { display: 'none' } }}>
    <ThemeProvider theme={forceMdTheme}>
      <Paper elevation={0} sx={{ p: 3, pageBreakAfter: 'always' }}>
        {title && (
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            variant="body1"
            gutterBottom
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'normal',
              overflowWrap: 'break-word',
            }}
          >
            {description}
          </Typography>
        )}
        <Box className="print-content" width={'1000px'}>
          {children}
        </Box>
      </Paper>
    </ThemeProvider>
  </Box>
);

export default PrintWrapper;
